var getUrlParameter = function getUrlParameter(sParam) {
        var sPageURL = decodeURIComponent(window.location.search.substring(1)),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : sParameterName[1];
            }
        }
    };

(function($) {
    function pictureRatio() {
        if ($(window).width() < 768) {
            $('.featured-products-slider .picture').height($('.featured-products-slider .picture').width());
        }
    }

    $(function() {

        /*Nyitő slider*/
        $('.main-slider').slick({
            arrows: false,
            dots: false,
            infinite: true,
            speed: 1000,
            fade: true,
            cssEase: 'ease',
            autoplay: true,
            autoplaySpeed: 3000,
        });


        /*Csapat tagok slider*/
        if ($('.others-slider').length) {
            $('.others-slider').each(function(index, el) {
                var $that = $(this).parent();

                $(this).on('init reInit', function(event, slick) {
                    var current = slick.slideCount / parseFloat(slick.options.slidesToShow);
                    if (current > 1) {
                        var currentrounded = Math.ceil(current.toFixed(2));
                        $that.find('.slide-counters').append('<span class="first-number">1</span><span class="temp">/</span><span class="second-number">' + currentrounded + '</span>');
                    }
                });

                $(this).slick({
                    arrows: true,
                    dots: false,
                    infinite: false,
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    prevArrow: $that.find('.arrow-left'),
                    nextArrow: $that.find('.arrow-right'),
                    responsive: [{
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                        }
                    }, {
                        breakpoint: 650,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        }
                    }]
                });
                $(this).on('afterChange', function(event, slick, currentSlide, nextSlide) {
                    var i = (currentSlide ? currentSlide : 0) + slick.options.slidesToShow;
                    var current = slick.slideCount / parseFloat(slick.options.slidesToShow);
                    if (current > 1) {
                        var currentrounded = Math.ceil(current.toFixed(2));
                        $that.find('.first-number').text(i / parseFloat(slick.options.slidesToShow));
                        $that.find('.second-number').text(currentrounded);
                    }
                });
            });
        }


        /*Kiemelt hírek slider*/
        if ($('.featured-news-slider').length) {
            $('.featured-news-slider').each(function(index, el) {
                var $that = $(this).parent();

                $(this).on('init reInit', function(event, slick) {
                    var current = slick.slideCount / parseFloat(slick.options.slidesToShow);
                    if (current > 1) {
                        var currentrounded = Math.ceil(current.toFixed(2));
                        $that.find('.slide-counters').append('<span class="first-number">1</span><span class="temp">/</span><span class="second-number">' + currentrounded + '</span>');
                    }
                });

                $(this).slick({
                    arrows: true,
                    dots: false,
                    infinite: false,
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    prevArrow: $that.find('.arrow-left'),
                    nextArrow: $that.find('.arrow-right'),
                    responsive: [{
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                        }
                    }, {
                        breakpoint: 650,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        }
                    }]
                });
                $(this).on('afterChange', function(event, slick, currentSlide, nextSlide) {
                    var i = (currentSlide ? currentSlide : 0) + slick.options.slidesToShow;
                    var current = slick.slideCount / parseFloat(slick.options.slidesToShow);
                    if (current > 1) {
                        var currentrounded = Math.ceil(current.toFixed(2));
                        $that.find('.first-number').text(i / parseFloat(slick.options.slidesToShow));
                        $that.find('.second-number').text(currentrounded);
                    }
                });
            });
        }

        /*Kiemelt termékek*/
        if ($('.featured-products-slider').length) {
            $('.featured-products-slider').each(function(index, el) {
                var $that = $(this).parent();

                $(this).on('init reInit', function(event, slick) {
                    var current = slick.slideCount / parseFloat(slick.options.slidesToShow);
                    if (current > 1) {
                        var currentrounded = Math.ceil(current.toFixed(2));
                        $that.find('.slide-counters').append('<span class="first-number">1</span><span class="temp">/</span><span class="second-number">' + currentrounded + '</span>');
                    }
                });

                $(this).slick({
                    arrows: true,
                    dots: false,
                    infinite: false,
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    prevArrow: $that.find('.arrow-left'),
                    nextArrow: $that.find('.arrow-right'),
                    responsive: [{
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                        }
                    }, {
                        breakpoint: 650,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        }
                    }]
                });
                $(this).on('afterChange', function(event, slick, currentSlide, nextSlide) {
                    var i = (currentSlide ? currentSlide : 0) + slick.options.slidesToShow;
                    var current = slick.slideCount / parseFloat(slick.options.slidesToShow);
                    if (current > 1) {
                        var currentrounded = Math.ceil(current.toFixed(2));
                        $that.find('.first-number').text(i / parseFloat(slick.options.slidesToShow));
                        $that.find('.second-number').text(currentrounded);
                    }
                });
            });
        }

        /*Vezetők Slider*/
        if ($('.managers-slider').length) {
            var $activeSlide = getUrlParameter('manager');

            $('.managers-slider').each(function(index, el) {
                var $that = $(this).parent();

                $(this).on('init reInit', function(event, slick) {
                    var current = slick.slideCount / parseFloat(slick.options.slidesToShow);
                    if (current > 1) {
                        var currentrounded = Math.ceil(current.toFixed(2));
                        $that.find('.slide-counters').append('<span class="first-number">1</span><span class="temp">/</span><span class="second-number">' + currentrounded + '</span>');
                    }
                });

                $(this).slick({
                    arrows: true,
                    dots: false,
                    infinite: false,
                    prevArrow: $that.find('.arrow-left'),
                    nextArrow: $that.find('.arrow-right'),
                });
                $(this).on('afterChange', function(event, slick, currentSlide, nextSlide) {
                    var i = (currentSlide ? currentSlide : 0) + slick.options.slidesToShow;
                    var current = slick.slideCount / parseFloat(slick.options.slidesToShow);
                    if (current > 1) {
                        var currentrounded = Math.ceil(current.toFixed(2));
                        $that.find('.first-number').text(i / parseFloat(slick.options.slidesToShow));
                        $that.find('.second-number').text(currentrounded);
                    }
                });

                if ($activeSlide != undefined) {
                    $(this).slick('slickGoTo', $('#' + $activeSlide).index(),true);
                    $("html, body").animate({ scrollTop: $('#' + $activeSlide).offset().top - $('header').height()  }, 1000);
                }
            });
        }


        pictureRatio();

        $(window).resize(function(event) {
            pictureRatio();
        });

        /*Szolgáltatások*/
        if ($('.services-slider').length) {
            $('.services-slider').each(function(index, el) {
                var $that = $(this).parent();

                $(this).on('init reInit', function(event, slick) {
                    var current = slick.slideCount / parseFloat(slick.options.slidesToShow);
                    if (current > 1) {
                        var currentrounded = Math.ceil(current.toFixed(2));
                        $that.find('.slide-counters').append('<span class="first-number">1</span><span class="temp">/</span><span class="second-number">' + currentrounded + '</span>');
                    }
                });

                $(this).slick({
                    arrows: true,
                    dots: false,
                    infinite: false,
                    prevArrow: $that.find('.arrow-left'),
                    nextArrow: $that.find('.arrow-right'),
                });
                $(this).on('afterChange', function(event, slick, currentSlide, nextSlide) {
                    var i = (currentSlide ? currentSlide : 0) + slick.options.slidesToShow;
                    var current = slick.slideCount / parseFloat(slick.options.slidesToShow);
                    if (current > 1) {
                        var currentrounded = Math.ceil(current.toFixed(2));
                        $that.find('.first-number').text(i / parseFloat(slick.options.slidesToShow));
                        $that.find('.second-number').text(currentrounded);
                    }
                });
            });
        }

    });
})(jQuery);